import { MapPin, Activity } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import Footer from "@/components/shared/Footer";

const ContactPage = () => {
  return (
    <main className="min-h-screen" style={{ background: '#F8FAFC' }}>
      <div className="container-shell py-16">
        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          <div>
            <div className="inline-flex items-center gap-2.5 px-3.5 py-2.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-4"
              style={{ background: '#fff', border: '1px solid #D9E4F2', color: '#416588' }}>
              <span className="w-2 h-2 rounded-full" style={{ background: 'linear-gradient(135deg,#1D4ED8,#3B82F6,#14B8A6)' }}></span>
              Contact
            </div>
            <h1 className="text-4xl font-bold mb-4" style={{ color: '#1E293B' }}>Get in Touch</h1>
            <p className="mb-8" style={{ color: '#475569' }}>
              Ready to transform your practice with predictive intelligence? Let's discuss how Trialeze can help.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: '#dbeafe' }}>
                  <MapPin className="h-5 w-5" style={{ color: '#3B82F6' }} />
                </div>
                <div>
                  <div className="font-semibold" style={{ color: '#1E293B' }}>Address</div>
                  <div style={{ color: '#475569' }}>864 Grand Ave Suite 408<br/>San Diego, CA 92109</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: '#dbeafe' }}>
                  <Activity className="h-5 w-5" style={{ color: '#3B82F6' }} />
                </div>
                <div>
                  <div className="font-semibold" style={{ color: '#1E293B' }}>Phone</div>
                  <div style={{ color: '#475569' }}>510-422-4451</div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="rounded-3xl p-8" style={{ background: '#fff', border: '1px solid #D9E4F2', boxShadow: '0 12px 30px rgba(15,23,42,.08)' }}>
            <h3 className="text-xl font-bold mb-6" style={{ color: '#1E293B' }}>Send a Message</h3>
            <div className="space-y-4">
              <div>
                <Label style={{ color: '#1E293B' }}>Name</Label>
                <Input className="mt-1 rounded-xl h-11" placeholder="Your name" />
              </div>
              <div>
                <Label style={{ color: '#1E293B' }}>Email</Label>
                <Input className="mt-1 rounded-xl h-11" placeholder="you@lawfirm.com" />
              </div>
              <div>
                <Label style={{ color: '#1E293B' }}>Firm</Label>
                <Input className="mt-1 rounded-xl h-11" placeholder="Your Law Firm LLP" />
              </div>
              <div>
                <Label style={{ color: '#1E293B' }}>Message</Label>
                <textarea className="mt-1 w-full rounded-xl p-3 border" rows={4} placeholder="How can we help?" style={{ borderColor: '#D9E4F2' }} />
              </div>
              <Button className="w-full rounded-xl h-12 font-bold text-white" style={{ background: 'linear-gradient(135deg,#1D4ED8,#3B82F6,#14B8A6)' }}>
                Send Message
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default ContactPage;
